import { render, staticRenderFns } from "./CartWarning.vue?vue&type=template&id=748a3dcf"
import script from "./CartWarning.vue?vue&type=script&lang=js"
export * from "./CartWarning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports